import React from "react";

import {
  getCareGoalAndObjectiveNoteVersion,
  getCareGoalAndObjectivesFromNote,
} from "@/features/notes/(v2)/helpers/workflow-functions";

import { PatientCarePlanWidget } from "../PatientCarePlanWidget";

import { GoalAndObjectiveWidget } from "./GoalAndObjectiveWidget";

/**
 * Displays below the video component in the guided session
 */
export const CarePlanWidget = ({ carePlanTips, noteContent, patientDetails }) => {
  const version = getCareGoalAndObjectiveNoteVersion(noteContent);
  const goalsObjectivesProgress = getCareGoalAndObjectivesFromNote(noteContent, version);

  return (
    <>
      {version === "1" && (
        <PatientCarePlanWidget carePlanTips={carePlanTips} patientDetails={patientDetails} />
      )}

      {version === "2" && (
        <GoalAndObjectiveWidget
          goalsObjectivesProgress={goalsObjectivesProgress}
          patientDetails={patientDetails}
        />
      )}
    </>
  );
};
